/**
 * Patterns — Mustererkennung, Analogien, Beziehungen.
 */
export const PATTERNS = [
  { id: 'pat01', cat: 'patterns', diff: 1,
    q: 'Welche Zahl passt? 2 : 4 wie 3 : ?', a: '6',
    hint: 'Verdoppeln', exp: '·2 → 6' },

  { id: 'pat02', cat: 'patterns', diff: 2,
    q: 'Welche Zahl passt? 2 : 4 wie 5 : ?', a: '25',
    hint: 'Quadrat?', exp: '2² = 4, also 5² = 25' },

  { id: 'pat03', cat: 'patterns', diff: 2,
    q: 'Welche Zahl fehlt? 4, 9, 16, ?, 36', a: '25',
    hint: 'Quadrate', exp: '2²,3²,4²,5²,6² → 25' },

  { id: 'pat04', cat: 'patterns', diff: 2,
    q: 'Welche Zahl passt? 6 : 36 wie 8 : ?', a: '64',
    hint: 'Quadrate', exp: '6²=36, 8²=64' },

  { id: 'pat05', cat: 'patterns', diff: 3,
    q: 'Welche Zahl fehlt? 1, 4, 9, ?, 25, 36', a: '16',
    hint: 'Quadratzahlen', exp: '1²,2²,3²,4²,5²,6²' },

  { id: 'pat06', cat: 'patterns', diff: 3,
    q: 'Welche Zahl passt? 27 : 9 wie 64 : ?', a: '16',
    hint: 'Kubikwurzel im Quadrat?', exp: '27 = 3³, √³·² Beziehung — oder: ³√27=3, 3²=9; ³√64=4, 4²=16' },

  { id: 'pat07', cat: 'patterns', diff: 2,
    q: 'Welches Verhältnis? 3 : 12 wie 5 : ?', a: '20',
    hint: 'Mal 4', exp: '·4 pro Schritt' },

  { id: 'pat08', cat: 'patterns', diff: 3,
    q: 'Welche Zahl fehlt? 2, 3, 5, 8, 12, ?', a: '17',
    hint: 'Differenz +1, +2, +3, +4, +5', exp: '12 + 5 = 17' },

  { id: 'pat09', cat: 'patterns', diff: 3,
    q: 'Welche Zahl fehlt? 81, 27, 9, 3, ?', a: '1',
    hint: 'Durch 3 teilen', exp: '÷3 pro Schritt' },

  { id: 'pat10', cat: 'patterns', diff: 4,
    q: 'Welche Zahl fehlt? 1, 11, 21, 1211, 111221, ?', a: '312211',
    hint: 'Lies die Zahl vor', exp: 'Look-and-Say: "drei 1, zwei 2, ein 1" = 312211' },

  { id: 'pat11', cat: 'patterns', diff: 2,
    q: 'Welche Zahl passt? 7 : 49 wie 9 : ?', a: '81',
    hint: 'Hoch zwei', exp: '9² = 81' },

  { id: 'pat12', cat: 'patterns', diff: 3,
    q: 'Welche Zahl fehlt? 1, 3, 6, 10, 15, ?', a: '21',
    hint: 'Dreieckszahlen', exp: '+2, +3, +4, +5, +6 → 21' },

  { id: 'pat13', cat: 'patterns', diff: 4,
    q: 'Welche Zahl fehlt? 2, 12, 36, 80, 150, ?', a: '252',
    hint: 'n²·(n+1)', exp: '1²·2, 2²·3, 3²·4, 4²·5, 5²·6, 6²·7 = 252' },

  { id: 'pat14', cat: 'patterns', diff: 2,
    q: 'Welche Zahl passt? 100 : 10 wie 144 : ?', a: '12',
    hint: 'Wurzel', exp: '√100=10, √144=12' },

  { id: 'pat15', cat: 'patterns', diff: 3,
    q: 'Welche Zahl fehlt? 0, 1, 4, 9, 16, 25, ?', a: '36',
    hint: 'Quadrate ab 0', exp: '0², 1², 2², 3², 4², 5², 6² = 36' },
];
